import React, { useEffect, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'react-redux'

import { getAvailableDates, getUserCountry } from '../../../services/api/LearnDanish'

import { SproglandCountryDialog } from '../../dialogs/SproglandCountryDialog'
import { AvailableSessions } from '../LearnDanish/AvailableSessions'
import PhoneInputForm from '../../formElements/PhoneInputForm'
import BookedSessions from '../LearnDanish/BookedSessions'
import { TypographyStyles } from '../../../styles'
import Layout from '../../../constants/Layout'
import SproglandInfo from './SproglandInfo'

export default function SproglandUserView({ getBookedSessions, bookedSessions, bookSession, juniorId }) {
	const navigation = useNavigation()
	const [availableDates, setAvailableDates] = useState([])
	const phoneNumber = useSelector((state) => state.user?.phone)
	const [countryDialogVisible, setCountryDialogVisible] = useState(false)

	useEffect(() => {
		fetchAvailableDates()
		getUserCountry().then((country) => {
			if (!country) setCountryDialogVisible(true)
		})
	}, [])

	function navigateToConversation(conversationId) {
		navigation.navigate('InboxStack', {
			screen: 'Conversation',
			initial: false,
			params: { id: conversationId },
		})
	}

	function navigateToNewConversation(userId, sessionId) {
		navigation.navigate('InboxStack', {
			screen: 'Conversation',
			initial: false,
			params: {
				id: 'new',
				receiverId: userId,
				slSessionId: sessionId,
			},
		})
	}

	async function fetchAvailableDates() {
		const dates = await getAvailableDates(juniorId)
		const updatedArray = dates.map((item) => ({ ...item, dates: [], dropdownActive: false }))
		setAvailableDates(updatedArray)
	}

	return (
		<View>
			{(phoneNumber === 0 || !phoneNumber) && (
				<View style={{ maxWidth: 400, alignSelf: 'center' }}>
					<PhoneInputForm buttonTitleStyle={{ ...TypographyStyles.textSmall }} />
				</View>
			)}

			<View style={styles.sessionContainer}>
				<View style={!Layout.isSmallDevice && styles.layout}>
					<View style={!Layout.isSmallDevice && styles.element}>
						<View style={!Layout.isSmallDevice && { flexDirection: 'row', justifyContent: 'space-evenly', flex: 4 }}>
							<View style={!Layout.isSmallDevice && { flex: 2 }}>
								<BookedSessions
									sessions={bookedSessions}
									loadSessions={getBookedSessions}
									reloadAvailable={fetchAvailableDates}
									startConversation
									navigateToConversation={navigateToConversation}
									navigateToNewConversation={navigateToNewConversation}
									navigation={navigation}
									juniorId={juniorId}
								/>
							</View>
							<View style={!Layout.isSmallDevice && { flex: 2 }}>
								<AvailableSessions
									availableDates={availableDates}
									getAvailableDates={fetchAvailableDates}
									getBookedSessions={getBookedSessions}
									bookSession={bookSession}
									juniorId={juniorId}
								/>
							</View>
						</View>
					</View>
				</View>

				<View style={[!Layout.isSmallDevice && styles.layout, { marginTop: 50 }]}>
					<View style={!Layout.isSmallDevice && styles.element}>
						<SproglandInfo />
					</View>
				</View>

				<SproglandCountryDialog
					countryDialogVisible={countryDialogVisible}
					setCountryDialogVisible={setCountryDialogVisible}
				/>
			</View>
		</View>
	)
}

const styles = StyleSheet.create({
	sessionContainer: {
		alignSelf: 'stretch',
		marginBottom: 20,
	},
	layout: {
		flexDirection: 'row',
		justifyContent: 'space-around',
	},
	element: {
		width: '100%',
		minWidth: 500,
		maxWidth: 900,
	},
})
